import { Config } from '../Config';
import {
  ProjectContentDto,
  ProjectDto,
  ProjectsData,
} from '../data/models/projectsService';
import { projectServicePrsPrefix } from '../utils/helper';
import { BaseApiClient } from './BaseAPIClient';

export class ProjectServiceApiClient extends BaseApiClient {
  constructor() {
    super(Config.ProjectService__AppConfig__ApiUrl);
  }

  async postProjectContent(
    projectId: number,
    contentUrn: string
  ): Promise<ProjectContentDto | undefined> {
    if (!Config.ProjectService__AppConfig__Enabled)
      return Promise.resolve(undefined);
    const path = `/api/Projects/${projectId}/content`;
    const postBody: ProjectContentDto = { urn: contentUrn };
    return await this.post<ProjectContentDto>(path, postBody);
  }

  async getProjectByPrsProduct(prsId: number) {
    if (!Config.ProjectService__AppConfig__Enabled)
      return Promise.resolve(undefined);
    const path = '/api/Projects';
    const contentUrn = `${projectServicePrsPrefix}${prsId}`;
    return await this.get<ProjectsData>(path, {
      filter: `contenturn:${contentUrn}`,
    });
  }

  async getProjects(
    keyword: string,
    organization: string,
    page: number,
    size: number
  ): Promise<ProjectsData | undefined> {
    if (!Config.ProjectService__AppConfig__Enabled)
      return Promise.resolve(undefined);
    const path = '/api/Projects';
    const skip = page * size;
    const limit = size;
    return await this.get<ProjectsData>(path, {
      keyword,
      filter: `organization:${organization}`,
      skip,
      limit,
    });
  }

  async removeFromProject(
    projectId: number,
    contentUrn: string
  ): Promise<void> {
    if (!Config.ProjectService__AppConfig__Enabled) return Promise.resolve();
    return await this.delete(
      `/api/projects/${projectId}/contents/urn:prs:${contentUrn}`
    );
  }

  async createProject(
    name: string,
    artistName: string,
    organization: string,
    contentUrn: string
  ): Promise<ProjectDto> {
    return this.post<ProjectDto>('/api/projects', {
      name,
      organization: { urn: `urn:admin:${organization}` },
      artist: {
        name: artistName,
        urn: `artist:${artistName}`,
      },
      projectContents: [{ urn: contentUrn }],
      // TODO: API validation fails without empty array.
      externalIds: [],
    });
  }
}

export const projectServiceApiClient = new ProjectServiceApiClient();
